<template>
  <component :is="componentName" @changeComponent="changeComponent"></component>
</template>
<script>
import paperList from './paperList/index';
import addPaper from './addPaper/index';
import addQuestion from './addQuestion/index';
import paperStatistics from './paperStatistics/index';
import { mapQuery } from '@/utils/util';
export default {
  components: {
    paperList,
    addPaper,
    addQuestion,
    paperStatistics,
  },
  data() {
    return {
      componentName: 'paperList',
    };
  },
  watch: {
    $route: {
      handler(route) {
        const { componentName } = route.query;
        componentName ? (this.componentName = componentName) : (this.componentName = 'paperList');
      },
      // 深度观察监听
      immediate: true,
      deep: true,
    },
  },
  methods: {
    changeComponent(componentName, query) {
      this.componentName = componentName;
      const url = `/saas/examPaperManagement.html${mapQuery({ componentName, ...query })}`;
      console.log(url);
      this.g_tourl(url, {});
    },
  },
};
</script>
<style lang="scss" scoped></style>
